window.CountryList = {
  US: 'US'
}